const baseTheme = {
  baseColors: {
    error: '#B20221',
    textLight: '#7e7470',
  }
}

export default baseTheme
